<template>
    <div>
        <Head title="Типи рибалки"/>
        <h1 class="mb-8 text-3xl font-bold">Тип рибалки</h1>
        <div class="flex items-center justify-between mb-6">
            <Link
                class="btn-indigo"
                :href="$route('types.create')"
            >
                <span>Створити</span>
                <span class="hidden md:inline"> тип рибалки</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Назва</th>
                    <th class="pb-4 pt-6 px-6">Опис</th>
                </tr>
                <tr v-for="type in types.data" :key="type.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('types.edit', type.id)"
                            tabindex="-1"
                        >
                            {{ type.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('types.edit', type.id)"
                            tabindex="-1"
                        >
                            {{ type.description }}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('types.edit', type.id)"
                            tabindex="-1"
                        >
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="types.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">Немає жодного запису</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="types.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        types: Object,
    },
    data() {
        return {
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
